var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"d":"M13.333 4L6 11.333 2.667 8","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }